<template>
  <div class="page">
    <Preview></Preview>
  </div>
</template>

<script>
import Preview from '../components/commerce/Preview';

export default {
  mounted() {},
  computed: {
    currentUser() {
      return window.localStorage.getItem('mm-platform-user');
    },
  },
  methods: {},
  components: {
    Preview,
  },
};
</script>
